import React from "react"
import trans from "trans"
import { ItemInterface, ReactSortable } from "react-sortablejs"

import {
    Icon,
    TextInput,
    Theme,
    Message,
    css,
} from "@bdfx/mergado-ui-kit"

import { ToastIconSize } from "template-list/containers/template-list";
import { CoordsType } from "shape-entities/components/shape";

const PolygonForm = ({ form, formName, change, shape }) => {
    if (!shape.points || shape.points.length < 1) {
        return <Message type="info" closeable={false} icon={<Icon type={'info-circle'} color={Theme.steelblue} size={ToastIconSize} />}>
            {trans("info_no_points")}
        </Message>
    }

    const list = shape.points.map((point, i) => { return { id: i } })

    return (
        <StyledDiv className={'polygon-form'}>
            <div style={{ margin: '10px 0' }}>{trans('points_coordinates')}</div>
            <table>
                <tr>
                    <th />
                    <th className={'center'}>x</th>
                    <th className={'center'}>y</th>
                    <th />
                </tr>

                <ReactSortable handle=".drag-handle" tag="tbody" list={list} setList={(list) => {
                    const newOrder = list.map((item) => item.id)
                    const order = shape.points.map((point, key) => key)
                    if (newOrder.join(',') !== order.join(',')) {
                        let updatedPoints = []
                        newOrder.forEach(idx => {
                            updatedPoints.push(shape.points[idx])
                        })
                        change(formName, `shapes.${shape.index}.points`, updatedPoints)
                    }
                }}>
                    {shape.points.map((point, key) => {
                        return <tr key={'point' + key}>
                            <td><span className="drag-handle"><Icon type={'arrows-v'} color={Theme.blue} />{key}</span></td>
                            <td>
                                <TextInput
                                    type={'number'}
                                    value={point.x}
                                    onChange={(val) => {
                                        let updatedPoints = [...shape.points]
                                        const point = updatedPoints[key]
                                        updatedPoints[key] = { ...point, x: val }
                                        change(formName, `shapes.${shape.index}.points`, updatedPoints)
                                    }}
                                />
                            </td>
                            <td>
                                <TextInput
                                    type={'number'}
                                    value={point.y}
                                    onChange={(val) => {
                                        let updatedPoints = [...shape.points]
                                        const point = updatedPoints[key]
                                        updatedPoints[key] = { ...point, y: val }
                                        change(formName, `shapes.${shape.index}.points`, updatedPoints)
                                    }}
                                />
                            </td>
                            <td>
                                <span
                                    title={trans('delete')}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        let updatedPoints = [...shape.points]
                                        updatedPoints.splice(key, 1)
                                        change(formName, `shapes.${shape.index}.points`, updatedPoints)
                                    }}>
                                    <Icon type={'close'} color={Theme.red} />
                                </span>
                                <span
                                    title={trans('add_point')}
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                        let updatedPoints = [...shape.points]
                                        const lastPoint = shape.points.length > 1 && shape.points[shape.points.length - 1] ? shape.points[shape.points.length - 1] : point
                                        const prevPoint = shape.points.length > 1 && shape.points[(key - 1)] ? shape.points[(key - 1) % (shape.points.length - 1)] : lastPoint

                                        const newPoint: CoordsType = {
                                            x: Math.round((point.x + prevPoint.x) / 2),
                                            y: Math.round((point.y + prevPoint.y) / 2),
                                        }
                                        updatedPoints.splice(key, 0, newPoint)
                                        change(formName, `shapes.${shape.index}.points`, updatedPoints)
                                    }}>
                                    <Icon type={'plus'} color={Theme.blue} />
                                </span>
                            </td>
                        </tr>
                    })}
                </ReactSortable>
            </table>
        </StyledDiv>
    )
}

const StyledDiv = css('div')({
    ' .drag-handle': {
        cursor: 'move',
    },
    ' > table': {
        width: '100%',
    },
})

export default PolygonForm